module.exports = __webpack_public_path__ + "img/AT0000002686903.5c282f9c.png";